import React from 'react';
import GlobalStyle from './globalStyles';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import Home from './pages/HomePage/Home';
import PrivacyPolicyNegocios from './pages/TermsAndPoliciesPage/TermsAndPolicies';
import PrivacyPolicyUsuarios from './pages/TermsAndPoliciesPage/PrivacyPolicyUsuarios';
import TermsAndConditionsUsuarios from './pages/TermsAndPoliciesPage/TermsAndConditionsUsuarios';
import DataDeletionRequest from './pages/TermsAndPoliciesPage/DataDeletionRequest';
import RestaurantAgreementPage from './pages/RestaurantAgreementPage/RestaurantAgreement';
import AfiliacionesPage from './pages/AfiliacionesPage/Afiliaciones';
import SobreNosotrosPage from './pages/SobreNosotrosPage/SobreNosotros';
import ReactGA from 'react-ga4';

const TRACKING_ID='UA-239766981-1';
ReactGA.initialize(TRACKING_ID) 

function App() {

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <GlobalStyle />
      <Routes>
         <Route path="/" element={<Home/>} />
         {/*<Route path="/planes" element={<Pricing/>} />
         <Route path="/descarga" element={<Banner/>} />
         <Route path="/contacto" element={<Footer/>} />*/}
         <Route path="/privacy-policies-anfitriones" element={<PrivacyPolicyNegocios/>} />
         <Route path="/privacy-policies-usuarios" element={<PrivacyPolicyUsuarios/>} />
         <Route path="/terminos-y-condiciones-usuarios" element={<TermsAndConditionsUsuarios/>} />
         <Route path="/data-deletion-request" element={<DataDeletionRequest/>} />
         <Route path="/acuerdo-comercial-restaurantes" element={<RestaurantAgreementPage/>} />
         <Route path="/afiliaciones" element={<AfiliacionesPage/>} />
         <Route path="/sobre-nosotros" element={<SobreNosotrosPage/>} />
      </Routes>
    </Router>
  );
}

export default App;
